import { Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProductUnitClient, ProductUnitDto } from '../../api-connector/sso-connector';
import { BaseAutocompleteControl } from '../base-autocomplete-control';

@Component({
  selector: 'app-product-unit-control',
  templateUrl: './product-unit-control.component.html',
  styleUrls: ['./product-unit-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductUnitControlComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ProductUnitControlComponent),
      multi: true,
    }
  ]
})
export class ProductUnitControlComponent extends BaseAutocompleteControl<ProductUnitDto> implements OnInit {

  constructor(private productUnitClient: ProductUnitClient) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  /**
   * Fetch product units from API
   */
  protected fetchItems(searchValue: string): Observable<ProductUnitDto[]> {
    return this.productUnitClient.getProductUnitByKeySearch(searchValue).pipe(
      map(items => items ?? [])
    );
  }

  /**
   * Get display value for product unit
   */
  getDisplayValue(item: ProductUnitDto | null): string {
    return item?.name ?? '';
  }

  /**
   * Check if value is a valid ProductUnitDto instance
   */
  protected isValidItem(value: any): boolean {
    return value instanceof ProductUnitDto;
  }
}
